/**
 * This file is the entry point for the application.
 * It imports the CSS file and initializes the functions on DOMContentLoaded event.
 */
import '../css/app.css';

import templates from './templates';
import { fadeElements } from './services/ui.service';
import { initShareButtons } from './services/share.service';
import { initReadMoreToggles } from './services/readMore';
import { initFacetwpSearchChips } from './services/facetwp';
import { initLoginRedirectCtas } from './services/loginRedirect';
import {
	initFundingHighlightTabHrefs,
	initFundingListingResetClearsHighlight,
	initFundingSidebarActiveFiltersHighlight,
} from './services/funding-facetwp';
import {
	initEventsManagerTicketSpacesSync,
	initEventsManagerDeferredGatewayInit,
} from './services/eventsManagerBooking';

// Register before DOMContentLoaded so we catch em_booking_form_init fired by EMP
// as soon as booking forms boot (can race theme DOMContentLoaded handlers).
initEventsManagerDeferredGatewayInit();

document.addEventListener('DOMContentLoaded', function() {
    templates();
    fadeElements();
    initShareButtons();
    initReadMoreToggles();
    initFacetwpSearchChips();
    initLoginRedirectCtas();
    initFundingHighlightTabHrefs();
    initFundingListingResetClearsHighlight();
    initFundingSidebarActiveFiltersHighlight();
    initEventsManagerTicketSpacesSync();
});

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('a').forEach(a => {
//     const href = a.getAttribute('href');
//     if (href && href.trim() === '#') {
//       if (a.querySelector('.link-dot')) return;
//       const dot = document.createElement('span');
//       dot.className = 'link-dot';
//       a.appendChild(dot);
//     }
//   });
// });
